import './style.scss'
import { getPlatform } from '../../tools/getPlatform'
function needGray(_startTime, _endTime) {
  let endTime = _endTime || new Date('2020/04/05 00:00:00').getTime()
  let startTime = _startTime || new Date('2020/04/03 00:00:00').getTime()
  let nowTime = new Date().getTime()
  return nowTime > startTime && nowTime < endTime
}

export default function(_startTime, _endTime) {
  let $platform = getPlatform()
  let notApps = !(
    $platform.isYixinliApp ||
    $platform.isCeShiApp ||
    $platform.isZiXunApp ||
    $platform.museAPPVersion
  )
  if (needGray(_startTime, _endTime) && notApps) {
    document.querySelector('html').setAttribute('class', 'gray-filter')
  }
}



// WEBPACK FOOTER //
// ./src/frontend-lib/component/PageGrayFilter/index.js